import { useEffect, useState } from "react";
// import chairman from'../Assets/Images/chairman.jpg'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload';
// import { getPrincipalMessage } from "../Service/Api"; 
const PrincipalMessage = () => {

  //  const [data, setData] = useState([]);

  //  useEffect(() => {
  //    const fetchData = async () => {
  //      const messages = await getPrincipalMessage();
  //      setData(messages);
  //    };
  //    fetchData();
  //  }, []);
  //  const emptyArray = [
  //    // { description: "“Educating the mind without educating the heart is no education at all.” Sacred Heart has been educating boys and girls since 1990; though much has changed over the years our mission remains the same. Sacred Heart is committed to developing students of high academic achievement, intellectual curiosity, and strong moral character. As a result, year after year Sacred Heart sends our respectful, responsible and compassionate young adults, who are well prepared to tackle the challenges that lay ahead. Since arriving at Sacred Heart in 2016, I have had the opportunity to observe this unique institution up close. I have seen its commitment to academic excellence, its dynamic student body, and incredibly committed faculty and a loving community where the students and families are proud and supportive of one another. As I walk down the hallways of the school every day, I can hear the chatter of eager minds; the shouts of excitement from the victorious athletes, the thumb of dancers feed and the sound of melodious voices harmonizing the perpetual energy, movement and enthusiasm permeate the atmosphere. Ours is a school with difference. We value creativity and innovation and strive to nurture them in our students. Sacred Heartians are groomed to become confident, articulate and enlightened young citizens ready to step into the global society with dignity, honour and integrity. Aristotle once said “Educating the mind without educating the heart is no education at all”. Even as we impart education to match the advancement in technology and globalization, we march our children ahead with Sacred Heart ethos of moral values and principles. We Endeavour constantly to instill these qualities in our children. We pride ourselves to help them grow and develop into sensitive, responsible God loving citizens of the future. May the Sacred Heart of Jesus bless us abundantly in all our endeavourers.", attachments: "director.jpg" },   
  //  ];

  return (
    <>
    <section className="page-header">
        <div className="page-header-bg"></div>
        <div className="page-header-shape-1"><LazyLoad><img src="https://webapi.entab.info/api/image/LCSD/public/Images/page-header-shape-1.png" alt="Loreto Convent School, Delhi Cantt"/></LazyLoad></div>
        <div className="container">
        <div className="page-header__inner">
            <ul className="thm-breadcrumb list-unstyled ml-0">
                <li><Link to="/"> Home</Link></li>
                <li> About Us </li>
                <li> Principal's Message  </li>
            </ul>
            <h2>Principal's Message </h2>
        </div>
        </div>
    </section>
    <section className="innerbody">
   <div className="container">
      {/* <div className="section-content">
         <div className="section-content">

         {data?.length > 0 ? data?.filter((div) => div.category === "Principal").map((item, index) => ( 
             <div className="row justify-content-center">
             <div className="col-md-12">
            
             <div className="wt-team-1"> <div className="wt-media"> <img src={`https://webapi.entab.info/api/image/${item.attachments}`} alt="Loreto Convent School, Delhi Cantt" className="img-fluid"/> </div></div>
                 <p>{item.message}</p>
  <p><b>May God Bless you</b><br/> {item.name}  <br/> {item.designation} </p>

            
         </div>
            </div>
            )):emptyArray.map((data, index) => ( <div key={index} className='row'>
              
             </div>
           ))}

         </div>
      </div> */}
      <div class="row justify-content-center">
               <div class="col-md-12">

                   <div class="wt-team-1"> <div class="wt-media"><LazyLoad> <img src="https://webapi.entab.info/api/image/LCSD/public/Images/Principal.jpg" alt="Loreto Convent School, Delhi Cantt" class="img-fluid" /> </LazyLoad>
                   <div class="team-social-center"> <ul class="team-social-bar"> <li><a href="javascript:void(0);"><i class="bi bi-facebook"></i></a></li> 
                   <li><a href="javascript:void(0);"><i class="bi bi-twitter"></i></a></li> <li><a href="javascript:void(0);"><i class="bi bi-instagram"></i></a></li> 
                   <li><a href="javascript:void(0);"><i class="bi bi-linkedin"></i></a></li> </ul> </div> </div> </div> <div class="wt-team-1-single"> <div align="justify"> 
                   <p>Dear Students, Parents and Staff,</p><div><br /></div>
<p>It is with great enthusiasm and a renewed sense of purpose that I welcome each one of you to the commencement of this new academic session 2025-2026. As we embark on this journey together, we find ourselves at a pivotal juncture—one brimming with opportunities to cultivate knowledge, instil wisdom, and explore the immense potential that lies within each of us.</p>
<p>I sincerely acknowledge and express my heartfelt gratitude to the Loreto Sisters, whose unwavering dedication and guidance over the years have played a pivotal role in empowering and educating the girl child.</p>
<p>Thank you, dear parents and stakeholders. Together, let us weave a tapestry of learning and growth that will resonate for years to come.</p>
<p>A big thank you to our staff, your erudition and mentorship form the bedrock of our success. Your unwavering commitment in nurturing the minds of future generations is both commendable and indispensable. </p>
<p>And to our students, I urge you to immerse yourselves in the wealth of knowledge that awaits, to meet each challenge with courage and each opportunity with generosity of spirit.</p>
<p>The legacy of this great institution shines in its never ceasing quest for perfection. The onus is on us all to add more radiant colours to its lustre. This year, let us not merely pursue knowledge but seek Verity. Let our lives be anchored in Sincerity, guided by Justice, driven by the spirit of Freedom and crowned with Felicity.</p>
 

                   
                   <div>God bless you!</div> <div>Warm regards</div><div><br /></div>  </div> </div>  <p className="bg-color-span">  Mrs. Alice Rose D’Lima <br /> (Principal) </p>

                  
               </div>
            </div>
   </div>
</section>
   </>
  )
}

export default PrincipalMessage